import { render, staticRenderFns } from "./IconLinkSec.vue?vue&type=template&id=c52382be&"
import script from "./IconLinkSec.vue?vue&type=script&lang=js&"
export * from "./IconLinkSec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c52382be')) {
      api.createRecord('c52382be', component.options)
    } else {
      api.reload('c52382be', component.options)
    }
    module.hot.accept("./IconLinkSec.vue?vue&type=template&id=c52382be&", function () {
      api.rerender('c52382be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconLinkSec.vue"
export default component.exports